export default function ({ store, route, redirect, res, error }) {
  const is_admin = store.state.auth.is_admin;

  if (!is_admin) {
    return redirect('/panel');
  }
}
